import React, { useCallback } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Tooltip from "antd/es/tooltip";
import cn from "classnames";
import { useIntl } from "react-intl";

import MarkerShape, { knownShapes } from "@mapmycustomers/shared/enum/MarkerShape";

import getMarkerShapeIcon from "@app/scene/map/utils/getMarkerShapeIcon";
import { getMarkerShapeDisplayName } from "@app/util/ui";

import styles from "./ShapePanel.module.scss";

export interface ShapePanelProps {
  className?: string;
  onChange?: (shape: MarkerShape) => void;
  value?: MarkerShape;
}

const ShapePanel: React.FC<ShapePanelProps> = ({ className, onChange, value }) => {
  const intl = useIntl();

  const handleChange = useCallback(
    (shape: MarkerShape) => {
      onChange?.(shape);
    },
    [onChange]
  );

  return (
    <div className={cn(styles.container, className)}>
      {knownShapes.map((shape) => (
        <Tooltip key={shape} title={getMarkerShapeDisplayName(intl, shape)}>
          <FontAwesomeIcon
            className={cn(styles.icon, { [styles.selected]: value === shape })}
            icon={getMarkerShapeIcon(shape)!}
            onClick={() => handleChange(shape)}
          />
        </Tooltip>
      ))}
    </div>
  );
};

export default ShapePanel;
